import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_WARRANTIES_CENTER = "listWarrantiesCenter";
export const GET_DETAIL_WARRANTIES_CENTER = "detailWarrantiesCenter";
export const SAVE_WARRANTIES_CENTER = "saveWarrantiesCenter";
export const UPDATE_WARRANTIES_CENTER = "updateWarrantiesCenter";
export const DELETE_WARRANTIES_CENTER = "deleteWarrantiesCenter";
export const UPLOAD_WARRANTIES_CENTER_IMAGE = "uploadWarrantiesCenter";
export const GET_DATA_SEARCH_WARRANTIES_CENTER = "getDataSearchWarrantiesCenter";
export const SET_DATA_SEARCH_WARRANTIES_CENTER = "setDataSearchWarrantiesCenter";
export const SET_LIST_WARRANTIES_CENTER = "setListWarrantiesCenter";
export const SET_DETAIL_WARRANTIES_CENTER = "setDetailWarrantiesCenter";
export const IMPORT_EXCEL_WARRANTIES_CENTER = "importWarrantiesCenter";
export const UPDATE_ORDER_WARRANTIES_CENTER = "updateOrderWarrantiesCenter";


const state = {
    listWarrantiesCenter: [],
    warrantiesCenter: {},
    dataSearch: []
};

const getters = {
    listWarrantiesCenter(state) {
        return state.listWarrantiesCenter;
    },
    warrantiesCenter(state) {
        return state.warrantiesCenter;
    },
    dataSearchWarrantiesCenter(state) {
        return state.dataSearch;
    },
};

const actions = {
    [GET_LIST_WARRANTIES_CENTER](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_WARRANTIES_CENTER).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_WARRANTIES_CENTER, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DATA_SEARCH_WARRANTIES_CENTER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_WARRANTIES_CENTER_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH_WARRANTIES_CENTER, data.data.warrantiesCenter);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_WARRANTIES_CENTER](context, id) {
    return new Promise(resolve => {
    ApiService.query(`${API.GET_DETAIL_WARRANTIES_CENTER}/${id}`).then(({data}) => {
    if (data.status) {
    context.commit(SET_DETAIL_WARRANTIES_CENTER, data);
    }
    resolve(data);
    });
    });
    },
    [UPLOAD_WARRANTIES_CENTER_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_WARRANTIES_CENTER_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [IMPORT_EXCEL_WARRANTIES_CENTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.IMPORT_EXCEL_WARRANTIES_CENTER}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [SAVE_WARRANTIES_CENTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_WARRANTIES_CENTER}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_WARRANTIES_CENTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_WARRANTIES_CENTER}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_ORDER_WARRANTIES_CENTER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${API.UPDATE_ORDER_WARRANTIES_CENTER}/${payload.id}/order`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_WARRANTIES_CENTER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_WARRANTIES_CENTER}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_WARRANTIES_CENTER](state, data) {
        state.listWarrantiesCenter = data.data;
    },
    [SET_DETAIL_WARRANTIES_CENTER](state, data) {
        state.warrantiesCenter = data.data;
    },
    [SET_DATA_SEARCH_WARRANTIES_CENTER](state, data) {
        state.dataSearch = data
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};